var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileCalendar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35156 1.9375H6.78125V4.125L10.6094 4.125L9.76172 2.21094C9.67969 2.04687 9.51562 1.9375 9.35156 1.9375ZM10.9375 5.4375L1.3125 5.4375L1.3125 11.125C1.3125 11.3711 1.50391 11.5625 1.75 11.5625H10.5C10.7188 11.5625 10.9375 11.3711 10.9375 11.125V5.4375ZM1.61328 4.125H5.46875V1.9375L2.87109 1.9375C2.70703 1.9375 2.54297 2.04688 2.48828 2.21094L1.61328 4.125ZM9.35156 0.625C10.0352 0.625 10.6641 1.03516 10.9375 1.66406L12.0859 4.23437C12.1953 4.45312 12.25 4.69922 12.25 4.94531V11.125C12.25 12.1094 11.457 12.875 10.5 12.875H1.75C0.765625 12.875 0 12.1094 0 11.125L0 4.94531C0 4.69922 0.0273438 4.45312 0.136719 4.23438L1.28516 1.66406C1.55859 1.03516 2.1875 0.625 2.87109 0.625L9.35156 0.625Z",
    fill: "#666C74"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCalendar);
export default __webpack_public_path__ + "static/media/profile-calendar.bdccdb9ba310a687aa314a6b636d631f.svg";
export { ForwardRef as ReactComponent };